import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Input from '@mui/material/Input';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import CircularProgress from '@mui/material/CircularProgress';
import translate from '../../utils/translations';
import /* replacePageHtml, */ { saveToSessionStorage, checkSessionStorage, showPageHtml } from '../../utils/password';

const useFocus = () => {
    const htmlElRef = useRef(null);
    const setFocus = () => {
        htmlElRef.current && htmlElRef.current.focus();
    };

    return [htmlElRef, setFocus];
};

const GATSBY_MIDDLEWARE_API_PATH = '/api/getPage';

const EnterPasswordParagraph = ({ pageContext, langcode, errorText }) => {
    const isPreview = process.env.NODE_ENV === 'development';
    const [password, setPassword] = useState();
    const [errorMessage, setErrorMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [inputRef] = useFocus();

    const sendPassword = async () => {
        const path = location.pathname;
        const json = {
            path,
            password,
            langcode,
            pageContext,
            isPreview
        };
        const url = (location.host === 'www.lhsystems.com' ||
            location.host === 'www.lhsystems.de' ||
            location.host === 'www.consulting-lhsystems.com' ||
            location.host === 'www.consulting-lhsystems.de') ?
            `https://middleware.lhsystems.com${GATSBY_MIDDLEWARE_API_PATH}` :
            `${process.env.GATSBY_MIDDLEWARE_URI}${GATSBY_MIDDLEWARE_API_PATH}`;

        setIsLoading(true);
        await fetch(url, {
            headers: {
                Accept: '*/*',
                'Content-Type': 'text/html',
                'Access-Control-Allow-Origin': '*',
            },
            credentials: 'include',
            method: 'POST',
            body: JSON.stringify(json),
        })
            .then(response => {
                setIsLoading(false);
                if (response.headers.get('Content-Type') === 'text/html') {
                    return response.text();
                }

                return response.json();
            })
            .then(data => {
                if (data.error) {
                    return setErrorMessage(data.error === 'Wrong password' ? errorText : data.error);
                }

                if (isPreview) {
                    showPageHtml();

                    return;
                }

                setErrorMessage();
                saveToSessionStorage(data, json);

                showPageHtml();

                // replacePageHtml(data);
            })['catch'](error => {
                setErrorMessage(`Failed to check password! Please notify the administrator. (${error})`);
                setIsLoading(false);
            });
    };

    const onInputChange = e => {
        setPassword(e.target.value);
    };

    const onKeyPress = e => {
        if (e.key === 'Enter') {
            sendPassword();
        }
    };

    useEffect(() => {
        const path = location.pathname;
        const html = checkSessionStorage({
            path,
            langcode,
            pageContext,
        });

        if (html) {
            // replacePageHtml(html);

            showPageHtml();
        }
    }, [langcode, pageContext]);

    return (
        <div className="password-block-wrapper">
            <div className="password-block-inner">
                <div style={{
                    height: '30px'
                }}>
                    {isLoading && <CircularProgress size={20} />}
                </div>
                <div className="password-field-wrapper">
                    <Input
                        autoFocus
                        ref={inputRef}
                        type="password"
                        id="enter-password"
                        placeholder={translate('enterPassword', langcode)}
                        onChange={onInputChange}
                        onKeyPress={onKeyPress}
                    />
                </div>
                <button
                    onClick={sendPassword}
                    key="send-password"
                    className="secondary-button"
                >
                    {translate('submit', langcode)}
                </button>

            </div>
            {errorMessage && (
                <div className="error-message">
                    <ReportProblemIcon />
                    {errorMessage}
                </div>
            )}
        </div>
    );
};

export default EnterPasswordParagraph;

EnterPasswordParagraph.propTypes = {
    pageContext: PropTypes.string.isRequired,
    langcode: PropTypes.string.isRequired,
    errorText: PropTypes.string.isRequired,
};
